import { render, staticRenderFns } from "./CallToActionA.vue?vue&type=template&id=1a6181dd&"
import script from "./CallToActionA.vue?vue&type=script&lang=js&"
export * from "./CallToActionA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports